import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../httpClient/RestApiService';


function deleteConnectedApplicationRequestConfig(id: String): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.14',
    httpMethod: 'DELETE',
    endpoint: 'connected-applications/' + id,
    serverWideRequest: false
  };
}

export function callDeleteConnectedApplication(id: String) {
  return makeJsonRestApiRequest<void, IResult>({
    config: deleteConnectedApplicationRequestConfig(id),
    request: null,
  });
}

